/* @flow */
import React from 'react';
import Timestamp from 'components/Timestamp.jsx';

type Props = {timestamp: Date, className?: string};

const ChatMessageTimestamp = ({timestamp, className}: Props) => { // eslint-disable-line
  return (
    <Timestamp
      className={className}
      date={timestamp}
      format="short"
    />
  );
};

export default ChatMessageTimestamp;



// WEBPACK FOOTER //
// ./src/chat/components/ChatMessageTimestamp.jsx